<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We do not sell or trade your personal information.</p>
    <p>We may share minimal data only with trusted service providers who help operate our platform (e.g., hosting, authentication systems) — and only as necessary to provide the service.</p>
  </div>
</template>